import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import './editor.scss';
import Edit from './edit';
import save from './save';
import metadata from './block.json';
import indexjson from './edit.json';
import advancejson from '@vayu-blocks/advance-panel/advance.json';
import { MdOutlineArticle } from "react-icons/md";

registerBlockType( metadata.name, {
	...metadata,
	attributes: {...indexjson, ...advancejson},
	edit: Edit,
	icon: <MdOutlineArticle style={{color:'#6c1bc3'}} />,
	save,

	__experimentalLabel: (attributes) => {
		if (attributes.tocTitle) {
			return attributes.tocTitle;
		}
		return __('Table Of Contents', 'vayu-blocks');
	}
});